import { createUseStyles } from "react-jss";

interface Props {
  role: any;
};

const useStyles = createUseStyles((theme: any) => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    borderRadius: '24px',
    overflow: 'hidden',
    backgroundImage: (props: Props) => `url("/resources/images/welcomescreen/${props.role}_default.png")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    gap: '50px',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: 'calc(100% - 96px)',
    marginTop: '200px',
    marginLeft: '100px',
    '& > span': {
      fontSize: '36px',
      fontWeight: '300',
    },
    '& > svg': {
      width: 'auto',
      height: '89px',
      minHeight: '89px',
      marginLeft: '-16px',
    },
    [theme.breakpoints.down('lg')]: {
      marginTop: '24px',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '800px',
    maxWidth: 'calc(100% - 100px)',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '48px',
    overflow: 'auto',
    marginLeft: '100px',
    '& > p': {
      color: '#003165',
      width: '50%',
      fontSize: '18px',
    },
    '&::after': {
      content: `''`,
      display: 'block',
      width: '100%',
      height: '24px',
    },
  },
}));

export default useStyles;